





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Modify, { typeModify } from './Service/Modify';
import DoModify, { typeDoModify } from './Service/DoModify';
import Delete from './Service/Delete';
import roleForm from './form.json';
import permissionModify from '../role-permission/modify.vue';

@Component({
  components: { permissionModify },
})
export default class roleModify extends Vue {
  private loading: boolean = false;

  private roleForm: Object = roleForm;

  private form: typeDoModify.request = {
    role: {},
  };

  get permission() {
    return this.$getCrud('branch/permission/info');
  }

  /**
   * getInfo 取得資料
   */
  public getInfo(): void {
    this.loading = true;
    const getter = new Modify({ p5_role_id: this.$route.params.p5_role_id });
    getter.get().then((d) => {
      this.form = d;
      this.loading = false;
    });
  }

  /** 設定權限 */
  public setPermission() {
    const per: any = this.$refs.permission;
    per.submitForm();
  }

  /** 送出表單 */
  public submitForm(formName: string) {
    /** 測試模式判定 */
    const myForm: any = this.$refs[formName];
    myForm.validate((valid: boolean): void => {
      if (valid) {
        const getter = new DoModify(this.form);
        getter.put().then(() => {
          this.getInfo();
        });
      } else {
        const msg: any = this.$t('Util.validateError');
        this.$message.error(msg);
      }
    });
  }

  /** 刪除功能，可複選 */
  public doDelete() {
    const item: any = this.form;
    const doDelete = new Delete(item);
    doDelete.delete().then(() => {
      this.$router.push('/permission/role/lists');
    });
  }

  private mounted() {
    this.$store.dispatch('setBread', {
      label: this.$t('Theme.modify'),
    });

    this.$bus.$on('info', () => {
      this.$router.replace(
        `/permission/role/info/${this.$route.params.p5_role_id}`,
      );
    });

    this.$bus.$on('save', () => {
      this.submitForm('form');
    });

    /** 從bus偵測刪除行為(複選) */
    this.$bus.$on('delete', () => {
      this.doDelete();
    });

    this.getInfo();
  }
}
